import { graphql, Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';
import {
    DisconnectFirmInstagramMutationInput,
    disconnectInstagramMutationResponse,
    disconnectInstagramMutation,
} from './__generated__/disconnectInstagramMutation.graphql';

const mutation = graphql`
    mutation disconnectInstagramMutation($input: DisconnectFirmInstagramMutationInput!) {
        disconnectFirmInstagramMutation(input: $input) {
            tradeFirm {
                instagram {
                    username
                    feed {
                        imageUrl
                        link
                    }
                }
            }
        }
    }
`;

export default async function(
    environment: Environment,
    input: DisconnectFirmInstagramMutationInput
): Promise<disconnectInstagramMutationResponse> {
    return await commitMutation<disconnectInstagramMutation>(environment, {
        variables: { input },
        mutation,
    });
}
